export default __webpack_public_path__ + "img/coupe-champagne.asset.fe506fae.png";